import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Customers from './views/Customers.vue'
import Invoices from './views/Invoices.vue'
import Invoice from './views/Invoice.vue'
import Receipt from './views/Receipt.vue'
import Receipts from './views/Receipts.vue'
import Ledger from './views/Ledger.vue'
import Meter from './views/Meter.vue'
import Vouchers from './views/Vouchers.vue'
import Voucher from './views/Voucher.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/vouchers',
      name: 'vouchers',
      component: Vouchers,
    },
    {
      path: '/docs/voucher/:voucher_id',
      name: 'voucher',
      component: Voucher,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/customers',
      name: 'customers',
      component: Customers,
    },
    {
      path: '/ledger',
      name: 'ledger',
      component: Ledger,
    },
    {
      path: '/docs/invoices',
      name: 'invoices',
      component: Invoices,
    },
    {
      path: '/docs/invoice/:invoice_id',
      name: 'invoice',
      component: Invoice,
    },
    {
      path: '/docs/receipts',
      name: 'receipts',
      component: Receipts,
    },
    {
      path: '/docs/receipt/:receipt_id',
      name: 'receipt',
      component: Receipt,
    },
    {
      path: '/meters',
      name: 'meters',
      component: Meter,
    },
  ],
})
